import React from "react";
import moment from "moment";
import context from "./../../lib/context.js";
import { Alert } from "react-bootstrap";
import { Checkbox } from "react-bootstrap";
import { browserHistory } from "react-router";
import DynamicContent from "../../lib/components/dynamic-content.jsx";

export default class TCConfirm extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillReceiveProps(nextProps) {

    }

    render() {
        const vm = this.props.vm;
        const errorMsg = this.props.errorMessage ? <Alert bsStyle="danger">{this.props.errorMessage}</Alert> : <div></div>;
        let hasError = false;

        let items = [];

        if (vm == null || vm.length == 0) {
            hasError = true;
            items.push(<div className="ap-fullsize ap-grid-result text-center">
                No Timecard Found!
            </div>);
        } else {
            for (let i = 0; i < vm.length; i++) {
                const timecard = vm[i];
                let alert = null;
                let warning = null;

                if (timecard.errors.length > 0) {
                    hasError = true;
                    alert = <Alert bsStyle="danger"><ul>{timecard.errors.map(err => <li key={err}>{err}</li>)}</ul></Alert>;
                }

                if (timecard.warnings.length > 0) {
                    warning = <Alert bsStyle="warning"><ul>{timecard.warnings.map(w => <li key={w}>{w}</li>)}</ul></Alert>;
                }

                items.push(
                    <div className="row">
                        <div className="col-sm-12 col-md-12 ap-tc-approval-list-item">
                            <div className="row">
                                <div className="col-sm-6 col-md-6">
                                    <span className="ap-label">
                                        Employee Name:</span>
                                    <span className="ap-value">
                                        {vm[i].peopleName}</span>
                                </div>
                                <div className="col-sm-6 col-md-6">
                                    <span className="ap-label">
                                        Total regular hours:</span>
                                    <span className="ap-value">
                                        {vm[i].regularHour} hr {vm[i].regularMin} min</span>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-sm-6 col-md-6">
                                    <span className="ap-label">
                                        Timecard ID:</span>
                                    <span className="ap-value">
                                        {vm[i].timecardId}</span>
                                </div>
                                <div className="col-sm-6 col-md-6">
                                    <span className="ap-label">
                                        Total overtime hours:</span>
                                    <span className="ap-value">
                                        {vm[i].otHour} hr {vm[i].otMin} min</span>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-sm-6 col-md-6">
                                    <span className="ap-label">
                                        Week Ending Date:</span>
                                    <span className="ap-value">
                                        {moment(vm[i].weekEnding).format("MM/DD/YYYY")}</span>
                                </div>
                                <div className="col-sm-6 col-md-6">
                                    <span className="ap-label">
                                        Total doubletime hours:</span>
                                    <span className="ap-value">
                                        {vm[i].dtHour} hr {vm[i].dtMin} min</span>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-sm-6 col-md-6">

                                </div>
                                <div className="col-sm-6 col-md-6">
                                    <span className="ap-label">
                                        Total miscellaneous hours:</span>
                                    <span className="ap-value">
                                        {vm[i].miscHour} hr {vm[i].miscMin} min</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    {warning}
                                </div>
                                <div className="col-md-12">
                                    {alert}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }
        }

        let isAgree = false;
        return (
            <div className="ap-form-container">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 col-md-8 col-md-offset-2">
                            {errorMsg}
                        </div>
                        <div className="col-sm-12 col-md-8 col-md-offset-2 ap-tc-approval ap-error-color">
                            <b>Please review all information on timecard(s) below before confirming</b>
                        </div>
                        <div className="col-sm-12 col-md-8 col-md-offset-2 ap-tc-approval-list">
                            {items}
                        </div>
                        <div className="col-sm-12 col-md-8 col-md-offset-2 ap-tc-approval">
                            <DynamicContent contentName="TC_Submit_Verbiage_Supervisor" role="Supervisor">
                                SUPERVISOR agrees to review and approve submitted timecards and completed tasks in a timely manner. Because COMPANY's employees must be paid for hours worked as legally required, if submitted hours lack timely SUPERVISOR approval, COMPANY will process payroll based upon the hours submitted by employee.
                                <br /><br />
                                SUPERVISOR agrees to review tasks to ensure accurate reporting of tasks performed.
                                <br /><br />
                                As a reminder, SUPERVISORS agree to comply with state and federal civil rights laws, and other employment-related laws, including meal/rest break periods per wage and hour laws for employees whom you supervise.
                                <br /><br />
                                Supervisors also must agree and comply with all laws and ordinances relating to work site health and safety, and agrees to provide employees a safe and healthful workplace.
                            </DynamicContent>
                        </div>
                        <div className={`${hasError ? "ap-hidden" : ""}`}>
                            <div className="col-sm-12 col-md-8 col-md-offset-2 ap-tc-approval">
                                <Checkbox onChange={(evt) => { isAgree = evt.target.checked; }}>
                                    <b>I have read and agree to the agreement stated above</b>
                                </Checkbox>
                            </div>
                            <div className="col-sm-12 col-md-8 col-md-offset-2 ap-tc-approval" style={{ paddingBottom: "10px" }}>
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <button className="btn btn-info ap-fullsize" onClick={() => this.props.onConfirm(isAgree)}>Confirm</button>
                                        </div>
                                        <div className="col-md-6">
                                            <button className="btn ap-fullsize"
                                                onClick={() => {
                                                    browserHistory.goBack();
                                                }}>Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`${hasError ? "col-sm-12 col-md-8 col-md-offset-2 ap-tc-approval" : "ap-hidden"}`} style={{ paddingBottom: "10px" }}>
                            <button className="btn ap-fullsize"
                                onClick={() => {
                                    browserHistory.goBack();
                                }}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>);
    }
}